import { SET_ACTIVE_ARTICLE, ARTICLE_LIST, UPDATE_ARTICLE } from '../constants'
const INITIAL_STATE = { article: null, articleList: null }

export default ( state = INITIAL_STATE, action ) => {
  switch( action.type ) {
    case SET_ACTIVE_ARTICLE:
      return { ...state, article: action.payload }
    case ARTICLE_LIST:
      return { ...state, articleList: action.payload }
    case UPDATE_ARTICLE:
      const articleList = state.articleList.map(art => {
        if( art.id === action.payload.id ) return action.payload;
        return art;
      })
      return { ...state, articleList }
    default: 
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/articlesReducer.js